import { GetAllOrganizationAgencyLinksByAgencyIdResponseBodyType } from "@intelligems/ig-types";
import { adminKeys } from "@src/api/queryKeys";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { api } from "../api";

const getOrganizationAgencyLinksByAgencyId = async (agencyId: string) => {
  const resp =
    await api.get<GetAllOrganizationAgencyLinksByAgencyIdResponseBodyType>(
      `/v2/admin/organizations/agencies/${agencyId}`
    );
  return resp.data;
};

export const useGetOrganizationAgencyLinksByAgencyId = (
  agencyId: string
): UseQueryResult<
  GetAllOrganizationAgencyLinksByAgencyIdResponseBodyType,
  Error
> => {
  return useQuery<
    GetAllOrganizationAgencyLinksByAgencyIdResponseBodyType,
    Error
  >({
    queryKey: adminKeys.organizationAgencyLink(agencyId),
    queryFn: async () => getOrganizationAgencyLinksByAgencyId(agencyId),
  });
};
